import React from "react";
import {
    Button,
    Col,
    Card,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    notification,
    Row,
    Space,
    Spin
} from "antd";
import {resourceList} from "../../consts";
import SupportedResourceCard from "./supportedResourceCard";
import {API} from "../../api";
import {withRouter} from "react-router-dom";
import QAViewWrapper from "./QAViewWrapper";
import {_getMappingData, handleError} from "../../utils/util";

const { RangePicker } = DatePicker;

message.config({
    duration: 3,
    maxCount: 3,
    rtl: false
});

//TODO replace sessionStorage eventually
class DataQA extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            client_id: !!sessionStorage.getItem(`${this.props.client.id}_client_id`) ? sessionStorage.getItem(`${this.props.client.id}_client_id`) : null,
            client_secret: !!sessionStorage.getItem(`${this.props.client.id}_client_secret`) ? sessionStorage.getItem(`${this.props.client.id}_client_secret`) : null,
            loading: false,
            selectedResource: resourceList[0],
            fhirResources: [],
            mappings: [],
            resourceType: null,
            namespace: null,
            version: null,
            allFhirResources: {},
            allMappings: {},
            isValid: false,
            renderCards: false,
            startDate: null,
            endDate: null,
        }
    }

    dateRange = async (value, dateString) => {
        this.setState({
            startDate: dateString[0],
            endDate: dateString[1]
        });
    }

    componentDidMount = async () => {
        await this.testCredentials();
        if (this.state.isValid){
            for (let resource of resourceList) {
                await this.getResource(resource);
                await this.getMappings(resource);
            }
            await this.setSelectedResource(this.state.selectedResource);
        }
    }

    testCredentials = async () =>{
        if (!!this.state.client_id === false || !!this.state.client_secret === false) {
            notification.error({description: "Please input a client id and client secret to retrieve data from the FHIR server"})
            return
        }
        let fhir = this.state.allFhirResources;
        const body = {
            "client_id": this.state.client_id,
            "client_secret": this.state.client_secret,
            "client_mapping_id": this.props.client.id,
            "resourceType": "Patient",
        }
        this.setState({loading:true})
        await API.post('/relay/fhir', body).then(res => {
            fhir['Patient'] = res.data.entry === undefined ? [] : res.data.entry;
            this.setState({
                isValid: true,
                allFhirResources: fhir
            })
        }).catch(error => {
            if (error.response.message === 'unauthorized' || error.message.includes('422')){
                this.setState({
                    client_id: "",
                    client_secret: "",
                    isValid: false,
                    loading: false
                })
            } else {
                handleError(error)
            }
        })
    }

    getMappings = async (resource) => {
        let resourceType = this.getResourceType(resource);
        await _getMappingData(this.props.client.id,
            'latest',
            resource.resourcetype,
            resource.namespace).then(res => {
                let mappings = this.state.allMappings;
                mappings[resourceType] = res.data.mappings;
                this.setState({allMappings: mappings})
            }).catch(error => handleError(error))
    }

    getResource = async (resource) => {
        let resourceType = this.getResourceType(resource);
        let fhir = this.state.allFhirResources;
        fhir[resourceType] = [];
        const body = {
            "client_id": this.state.client_id,
            "client_secret": this.state.client_secret,
            "resourceType": resourceType,
            "client_mapping_id": this.props.client.id,
            "endDate": this.state.endDate,
            "startDate": this.state.startDate,
        }
        API.post('/relay/fhir', body).then(res => {
            fhir[resourceType] = res.data.entry === undefined ? [] : res.data.entry;
        }).catch(error => {
            handleError(error);
        }).finally (() => {
            this.setState({
                allFhirResources: fhir
            })
        })
    }

    getResourceType(resource){
        let resourceType = resource.resourcetype;
        let type = resource.resourceName.split(' ').slice(-1);
        if(resourceType === "ExplanationOfBenefit"){
            resourceType = resourceType + "?type.coding.code=" + type;
        }
        return resourceType;
    }

    getResources = async() => {
        await this.testCredentials();
        if (this.state.isValid){
            for (let resource of resourceList) {
                if (resource !== "Patient") {
                    await this.getResource(resource);
                }
                await this.getMappings(resource);
            }
            await this.setSelectedResource(this.state.selectedResource);
        } else {
            notification.error({
                description:  `Client ID/Client Secret not found. Try again.`,
                duration: 6
            });
            this.setState({renderCards: false})
        }
    }

    onFinish = async (values) => {
        this.setState({
            client_id: values.client_id,
            client_secret: values.client_secret,
            base_url: values.base_url,
            loading: true,
            renderCards: false
        })
        sessionStorage.setItem(`${this.props.client.id}_client_id`, values.client_id)
        sessionStorage.setItem(`${this.props.client.id}_client_secret`, values.client_secret)
        await this.getResources();
    };



    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    setSelectedResource = async(selectedResource) => {
        let resourceType = this.getResourceType(selectedResource);
        this.setState({
            selectedResource,
            mappings: this.state.allMappings[resourceType],
            fhirResources: this.state.allFhirResources[resourceType],
            resourceType: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].resourceType : null,
            namespace: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].namespace : null,
            version: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].version : null,
            loading: Object.keys(this.state.allFhirResources).length === (resourceList.length) ? false : true,
            renderCards: Object.keys(this.state.allFhirResources).length === (resourceList.length) ? true : false
        }, () => {})
    }

    setSearchFilter = (key, value) => {
        if (key && value){
            this.setState({fhirResources: this.state.fhirResources[key].filter(item => item.key.toLowerCase() === value.toLowerCase)}, () => {
            })
        } else if (key) {
            this.setState({fhirResources: this.state.fhirResources[key].filter(item => item.key)}, () => {
            })
        } else {
            this.setState({fhirResources: this.state.fhirResources.filter(item => Object.values(item).indexOf(value) > -1)}, () => {
            })
        }
    }

    render() {
        return (
            <>
                <Row align="middle" gutter={[24, 16]}>
                    <Col>
                        <Form
                            name="basic"
                            layout="inline"
                            initialValues={{remember: true}}
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item
                                name="base_url"
                                initialValue={this.props.client.fhir_api_url}
                            >
                                <Input disabled
                                       addonBefore="FHIR API URL: "/>
                            </Form.Item>
                            <Form.Item
                                name="client_id"
                                initialValue={this.state.client_id}
                                rules={[{required: true, message: 'Please input a client_id'}]}
                            >
                                <Input className="data-qa-input-width"
                                       addonBefore="Client ID: "/>
                            </Form.Item>

                            <Form.Item
                                name="client_secret"
                                initialValue={this.state.client_secret}
                                rules={[{required: true, message: 'Please input a client_secret'}]}
                            >
                                <Input.Password className="data-qa-input-width"
                                       addonBefore="Client Secret: "/>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.state.loading}>
                                    Search
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <Divider style={{marginTop: 0}}/>
                <Row gutter={[24, 16]}>
                    <Col span={4}>
                        <Card title="Supported Resources" className="supported-resources">
                            {
                                this.state.renderCards && ""
                            }
                            {resourceList.map((resource) => {
                                return <SupportedResourceCard key={Math.random()}
                                                              resource={resource}
                                                              selectedResource={this.state.selectedResource}
                                                              setSelectedResource={this.setSelectedResource}
                                />
                            })}
                        </Card>
                    </Col>
                    <Col span={20}>
                        <Card>
                            <Button
                                style={{float: 'right', alignSelf: 'flex-end'}}
                                onClick={(e) => [e.stopPropagation(), this.getResources()]}>
                                Filter
                            </Button>
                            <Space style={{float: 'right'}} direction="vertical" size={12}>
                                <RangePicker onChange={this.dateRange}/>
                            </Space>
                            <Row>
                                <h4>Resource: <b style={{color: '#1890ff'}}>{this.state.selectedResource.resourceName}</b></h4>
                                <Divider />
                            </Row>
                            {
                                this.state.loading && <Spin />
                            }
                            {
                                this.state.renderCards && !this.state.loading && this.state.mappings &&
                                    <QAViewWrapper resource={this.state.fhirResources}
                                                   key={Math.random()}
                                                   showPagination={true}
                                                   type={this.state.selectedResource.resourceName}
                                                   selectedResource={null}
                                                   mappings={this.state.mappings}
                                                   resourcetype={this.state.resourceType}
                                                   namespace={this.state.namespace}
                                                   version={this.state.version}
                                                   client={this.state.client}
                                                   reference={true} />
                            }
                        </Card>
                    </Col>
                </Row>
            </>
        )
    }
}

export default withRouter(DataQA);